<template>
    <div id="animation-container">
        <transition name="fade" appear>
            <LogoPartLine1 id="line1" class="logo-part"></LogoPartLine1>
        </transition>
        <transition name="fade" appear>
            <LogoPartLine2 id="line2" class="logo-part"></LogoPartLine2>
        </transition>
        <transition name="fade" appear>
            <LogoPartLine2 id="line2repeat" class="logo-part"></LogoPartLine2>
        </transition>
        <transition name="fade" appear>
            <LogoPartLine3 id="line3" class="logo-part"></LogoPartLine3>
        </transition>
        <transition name="fade" appear>
            <LogoPartLine3 id="line3repeat" class="logo-part"></LogoPartLine3>
        </transition>
        <transition name="fade" appear>
            <LogoPartCircle1 id="circle1" class="logo-part"></LogoPartCircle1>
        </transition>
        <transition name="fade" appear>
            <LogoPartCircle2 id="circle2" class="logo-part"></LogoPartCircle2>
        </transition>
        <transition name="fade" appear>
            <LogoPartCircle3 id="circle3" class="logo-part"></LogoPartCircle3>
        </transition>
        <transition name="fade" appear>
            <LogoPartCircle3 id="circle3repeat" class="logo-part"></LogoPartCircle3>
        </transition>
        <transition name="fade" appear>
            <LogoPartCircle4 id="circle4" class="logo-part"></LogoPartCircle4>
        </transition>
        <transition name="fade" appear>
            <LogoComplete id="logo-complete"></LogoComplete>
        </transition>
    </div>
</template>

<script>
// import Helper from '../helpers/helper'
import LogoPartLine1 from '../assets/img/logoparts/line1.svg'
import LogoPartLine2 from '../assets/img/logoparts/line2.svg'
import LogoPartLine3 from '../assets/img/logoparts/line3.svg'
import LogoPartCircle1 from '../assets/img/logoparts/circle1.svg'
import LogoPartCircle2 from '../assets/img/logoparts/circle2.svg'
import LogoPartCircle3 from '../assets/img/logoparts/circle3.svg'
import LogoPartCircle4 from '../assets/img/logoparts/circle4.svg'
import LogoComplete from '../assets/img/logoparts/logo-complete.svg'
import { EventBus } from '@/event-bus'
import Helper from '../helpers/helper'

export default {
  name: 'LogoAnimation',
  components: {
    LogoPartLine1,
    LogoPartLine2,
    LogoPartLine3,
    LogoPartCircle1,
    LogoPartCircle2,
    LogoPartCircle3,
    LogoPartCircle4,
    LogoComplete
  },
  data: function () {
    return {
      showParts: true
    }
  },
  methods: {
    completeLogoLeftPosition () {
      const container = document.getElementById('animation-container')
      const containerWidth = Helper.elementWidth(container)
      const logoComplete = document.getElementById('logo-complete')
      const logoCompleteWidth = logoComplete.getBoundingClientRect().width
      var logoCompleteLeftPosition = ((containerWidth - logoCompleteWidth) / 2)
      logoComplete.style.left = logoCompleteLeftPosition
    },
    showCompleteLogo () {
      const logoComplete = document.getElementById('logo-complete')
      const logoParts = document.getElementsByClassName('logo-part')
      logoComplete.style.opacity = '1'
      for (var i = 0; i < logoParts.length; i++) {
        logoParts[i].style.opacity = '0'
      }
    },
    showLogoParts () {
      const logoComplete = document.getElementById('logo-complete')
      const logoParts = document.getElementsByClassName('logo-part')
      logoComplete.style.opacity = '0'
      for (var i = 0; i < logoParts.length; i++) {
        logoParts[i].style.opacity = '1'
      }
    }
  },
  mounted () {
    // const container = document.getElementsByClassName('animation-container')[0]
    // Helper.elementWidth(container)
    this.completeLogoLeftPosition()
    EventBus.$on('showCompleteLogo', () => {
      this.showCompleteLogo()
    })
    EventBus.$on('showParts', () => {
      this.showLogoParts()
    })
  }
}
</script>

<style lang="scss">
#animation-container{
    position: relative;
    min-height: 100vh;
    padding: 500px 0 1000px;
    overflow: hidden;
    svg{
        position: absolute;
    }
    #line1{
        top: 150px;
        left: 5%;
    }
    #line2{
        top: 40px;
        left: 45%;
    }
    #line2repeat{
        top: 50%;
        left: 50%;
    }
    #line3{
        top: 40%;
        left: -2%;
    }
    #line3repeat{
        top: 10%;
        right: 200px;
    }
    #circle1{
        top: 700px;
        left: 20%;
    }
    #circle2{
        top: 650px;
        left: 80%;
    }
    #circle3{
        top: 300px;
        left: 20%;
    }
    #circle3repeat{
        top: 55%;
        left: 0%;
    }
    #circle4{
        top: 250px;
        right: 18%;
    }
    #logo-complete{
        top: 650px;
        opacity: 0;
    }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
  transition-delay: .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@media screen and (max-width: 600px){
  #animation-container{
    position: relative;
    min-height: 100vh;
    padding: 500px 0 700px;
    #circle1, #circle2, #circle3, #circle3repeat, #circle4{
      width: 149px;
      height: auto;
    }
    #circle3{
      left: -9%;
    }
    #circle4{
      right: -10px;
    }
    #line1{
      width: 110px;
      height: auto;
      left: 60%;
    }
    #line2, #line2repeat{
      width: 38px;
      height: auto;
    }
    #line3, #line3repeat{
      width: 75px;
      height: auto;
    }
    #line3repeat{
      left: 0;
    }
    #logo-complete{
      width: 300px;
      height: auto;
    }
  }
}
</style>
